// IND-048: tamaño de un elemento (alto de una barra fija para colocar debajo
// la cabecera de la lista; ancho de la tabla para repartir sus columnas). Se
// pasa el elemento (ref de estado) para medirlo también dentro de un diálogo.
import { useEffect, useState } from 'react';

export function useElementSize(element: HTMLElement | null): { width: number; height: number } {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (!element) return undefined;
    const update = () => {
      const box = element.getBoundingClientRect();
      setSize((current) =>
        current.width === box.width && current.height === box.height ? current : { width: box.width, height: box.height });
    };
    update();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return size;
}

export function useElementHeight(element: HTMLElement | null): number {
  return useElementSize(element).height;
}
